import { useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { DropzoneField } from '@mews-commander/form';
import { useGetAvatarSrc } from '@mews-commander/utils';
import { FormInputField, FormNumberInputField, FormTextareaField, lt } from '@mews/framework';
import { Card, IconButton, IconName, Image, Stack, Typography } from '@optimus-web/core';
import { FieldNames, type FormValues } from '../formEnums';

interface Props {
    imageId?: string;
}
export const GuestFacingFields = ({ imageId }: Props) => {
    const [hideImage, setHideImage] = useState(false);
    const { setValue } = useFormContext<FormValues>();

    const getImgSrc = useGetAvatarSrc();

    const productImgSrc = getImgSrc(imageId);

    const handleImageDelete = () => {
        setValue(FieldNames.ImageId, null);
        setHideImage(true);
    };

    return (
        <>
            <Stack vertical spacing="100">
                <Typography textStyle="bodyLargeStrong" as="div">
                    {lt('GuestFacingDetails')}
                </Typography>
                <Typography textStyle="bodyMedium" variant="secondary" as="div">
                    {lt('GuestFacingDetailsDescription')}
                </Typography>
            </Stack>
            <FormInputField label={lt('ExternalName')} name={FieldNames.ExternalName} />
            <FormTextareaField label={lt('Description')} name={FieldNames.Description} rows={4} />
            <FormNumberInputField name={FieldNames.Ordering} label={lt('Ordering')} required />
            {productImgSrc && !hideImage ? (
                <Stack vertical spacing="50">
                    <Typography textStyle="bodyMediumStrong" as="div">
                        {lt('Image')}
                    </Typography>
                    <Card padding="100" color="black">
                        <Stack itemAlignment="center" distribution="space-between">
                            <Image height={48} width={86} rounded src={productImgSrc} objectFit="cover" />
                            <IconButton
                                variant="ghost"
                                icon={IconName.Delete}
                                type="button"
                                onClick={handleImageDelete}
                            />
                        </Stack>
                    </Card>
                </Stack>
            ) : (
                <>
                    <DropzoneField label={lt('Image')} name={FieldNames.Image} accept=".jpg, .jpeg, .png" />
                    <Typography textStyle="bodyMedium" variant="secondary" as="div">
                        {lt('ConfigureProductDescriptionProductImage')}
                    </Typography>
                </>
            )}
        </>
    );
};
